<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <h3 class="primary--text mb-5" v-if="userAreaIsGarantia">INCLUIR NOVA EMPRESA</h3>
    <div class="d-flex justify-start">
      <CardDescriptionButton
        class="mr-5"
        :name="textTomadorMatriz"
        @click="goToTomador"
      />
      <CardDescriptionButton 
        :name="textTomadorFilial"
        @click="goToSubsidiary"
      />
    </div>
  </Main>
</template>

<script>
import { mapState } from "vuex";
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";

const BREADCRUMB_ADICIONAR_TOMADOR_FILIAL = [
  {
    text: "Adicionar Tomador Matriz ou Filial",
    to: "economic_group view"
  }
];

const BREADCRUMB_ADICIONAR_EMPRESA = [
  {
    text: "Adicionar Empresa",
    to: "economic_group view"
  }
];

export default {
  name: "NewTomadorOrSubsidiary",
  created(){
    this.insertValuesOnBreadcrumb();
  },
  components: {
    CardDescriptionButton
  },
  data: () =>({
    breadcrumb: null
  }),
  computed: {
    ...mapState("me", ["userAreaIsGarantia"]),
    textTomadorMatriz() {
      return this.userAreaIsGarantia ? "Tomador Matriz" : "Matriz";
    },
    textTomadorFilial() {
      return this.userAreaIsGarantia ? "Tomador Filial" : "Filial";
    },
    groupId() {
      return this.$route.params.groupId;
    },
  },
  methods: {
    insertValuesOnBreadcrumb() {
      this.breadcrumb = this.userAreaIsGarantia ? BREADCRUMB_ADICIONAR_TOMADOR_FILIAL : BREADCRUMB_ADICIONAR_EMPRESA;
    },
    previousPage() {
      this.$router.push({
        name: "economic_group companies list",
        params: { groupId: this.groupId }
      });
    },
    goToTomador() {
      this.$router.push({
        name: "add economic_group company",
        params: { groupId: this.groupId }
      });
    },
    goToSubsidiary() {
      this.$router.push({
        name: "add economic_group subsidiary",
        params: { groupId: this.groupId }
      });
    }
  }
};
</script>
